<template>
  <div>
    <p class="caption light text-xs-left mb-0">Does your business charge Tax (VAT, GST, Sales Tax)?</p>
    <v-radio-group  :value="chargeTax" @change="chargeTaxEmit" hide-details row class="mt-0 pt-2 mb-3">
        <v-radio color="primary" label="Yes" :value='true' ></v-radio>
        <v-radio color="primary" label="No" :value='false'></v-radio>
      </v-radio-group>
    <transition name="fade">
    <div v-if="chargeTax">
    <p class="caption light text-xs-left mb-0">What is your Tax called?</p>
      <v-radio-group :value="taxLabel" @change="taxLabelEmit" :disabled="!chargeTax" hide-details row class="mt-0 pt-2 mb-3">
        <v-radio color="primary" label="VAT" value="VAT"></v-radio>
        <v-radio color="primary" label="GST" value="GST"></v-radio>
        <v-radio color="primary" label="Sales Tax" value="Sales Tax"></v-radio>
      </v-radio-group>
    <p class="caption light text-xs-left mb-0">Do the prices you enter include the {{ taxLabel || "VAT" }} portion?</p>
      <v-radio-group :value="taxCalcInclusive" @change="taxCalcInclusiveEmit" :disabled="!chargeTax" hide-details row class="mt-0 pt-2 mb-3">
        <v-radio color="primary" label="Yes" :value='true'></v-radio>
        <v-radio color="primary" label="No" :value='false'></v-radio>
      </v-radio-group>
    <p class="caption light text-xs-left mb-0">Display all totals within the app with {{ taxLabel || "VAT" }} included?</p>
      <v-radio-group :value="displayWithTax" @change="displayWithTaxEmit" :disabled="!chargeTax" hide-details row class="mt-0 pt-2 mb-3">
        <v-radio color="primary" label="Yes" :value='true'></v-radio>
        <v-radio color="primary" label="No" :value='false'></v-radio>
      </v-radio-group>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    chargeTax: {
      type: Boolean,
      default: false
    },
    taxCalcInclusive: {
      type: Boolean,
      default: true
    },
    displayWithTax: {
      type: Boolean,
      default: true
    },
    taxLabel: {
      type: String,
      default: 'VAT'
    }
  },
  watch: {
    chargeTax (newValue) {
      if (!newValue) {
        this.$emit('update:taxCalcInclusive', true)
        this.$emit('update:displayWithTax', true)
      }
    }
  },
  methods: {
    chargeTaxEmit (value) {
      this.$emit('update:chargeTax', value)
    },
    taxCalcInclusiveEmit (value) {
      this.$emit('update:taxCalcInclusive', value)
    },
    displayWithTaxEmit (value) {
      this.$emit('update:displayWithTax', value)
    },
    taxLabelEmit (value) {
      this.$emit('update:taxLabel', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
